
import React, { useState, useEffect } from 'react';
import styles from './upload.module.css';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import circuit from '../assets/videos/circuit.mp4';
const baseUrl = "https://coded-backend.onrender.com";
//  const baseUrl = "http://localhost:5000";
 // Log the token to verify it's being retrieved correctly
const Upload = () => {

  
  // console.log('Token:', token); // Log the token to verify it's being retrieved correctly
  const [courses, setCourses] = useState([]);
  const [modules, setModules] = useState([]);
  const [loadingData, setLoadingData] = useState(true);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploading, setUploading] = useState(false);
const token = localStorage.getItem('token');
console.log('Token:', token); 
  const {
    register,
    handleSubmit,
    watch,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      courseId: '',
      moduleId: '',
      title: '',
      description: '',
      video: null,
      order: '',
      isPreview: false,
      isPublished: false,
    },
  });

  const selectedCourseId = watch('courseId');
  const selectedVideo = watch('video');

  /* ---------------- FETCH DATA ---------------- */

  useEffect(() => {
    const loadData = async () => {
      try {
        const [courseRes, moduleRes] = await Promise.all([
          fetch(`${baseUrl}/courses`, {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`
            }
          }),
          fetch(`${baseUrl}/modules`, {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`
            },
          })
        ]);

        const coursesData = await courseRes.json();
        const modulesData = await moduleRes.json();

        setCourses(coursesData);
        setModules(modulesData);
      } catch (err) {
        console.error('Failed to load data:', err);
      } finally {
        setLoadingData(false);
      }
    };

    loadData();
  }, []);

  /* -------- RESET MODULE WHEN COURSE CHANGES -------- */
  useEffect(() => {
    setValue('moduleId', '');
  }, [selectedCourseId, setValue]);

  /* ---------------- SUBMIT ---------------- */

  const onSubmit = async (data) => {
    if (!data.video || data.video.length === 0) {
      alert('Please select a video file');
      return;
    }

    const file = data.video[0];

    // Check file size (Cloudinary free tier max = 100 MB)
    if (file.size > 100 * 1024 * 1024) {
      alert('File too large. Maximum allowed size is 100 MB.');
      return;
    }

    try {
      const formData = new FormData();

      // Append video file
      formData.append('file', file);

      // Append other fields
      Object.entries(data).forEach(([key, value]) => {
        if (key !== 'video') formData.append(key, value);
      });

      setUploading(true);
      setUploadProgress(0);

      const response = await axios.post(`${baseUrl}/lessons/media`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' ,
                    'Authorization': `Bearer ${token}`
        },
    
        onUploadProgress: (progressEvent) => {
          const percent = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          setUploadProgress(percent);
        },
      });

      console.log('Lesson created:', response.data);
      alert('Lesson uploaded successfully');
      reset();
      setUploadProgress(0);
    } catch (error) {
      console.error(error);
      alert(error.response?.data?.error || error.message || 'Upload failed');
      //  alert("the error is here")
    } finally {
      setUploading(false);
    }
  };

  if (loadingData) {
    return (
      <div className={styles.loadingContainer}>
        <p className={styles.loading}>Loading data...</p>
      </div>
    );
  }

  return (
    <div className={styles.uploadContainer}>
      <section className={styles.headerSection}>
        <h1>ADMIN VIDEO UPLOAD</h1>
      </section>

      <div className={styles.bodySection}>
        <section className={styles.formSection}>
          <form onSubmit={handleSubmit(onSubmit)} className={styles.uploadForm}>
            {/* COURSE */}
            <select {...register('courseId', { required: true })} className={styles.inputField}>
              <option value="">Select Course</option>
              {courses.length > 0 && courses.map((course) => (
                <option key={course._id} value={course._id}>
                  {course.title}
                </option>
              ))}
            </select>
            {errors.courseId && <span className={styles.errorText}>Course is required</span>}

            {/* MODULE */}
            <select
              {...register('moduleId', { required: true })}
              className={styles.inputField}
              disabled={!selectedCourseId}
            >
              <option value="">Select Module</option>
              {modules.length > 0 && modules.map((module) => (
                <option key={module._id} value={module._id}>
                  {module.title}
                </option>
              ))}
            </select>
            {errors.moduleId && <span className={styles.errorText}>Module is required</span>}

            {/* TITLE */}
            <input
              type="text"
              placeholder="Video Title"
              {...register('title', { required: true })}
              className={styles.inputField}
            />
            {errors.title && <span className={styles.errorText}>Title is required</span>}

            {/* DESCRIPTION */}
            <textarea
              placeholder="Description (optional)"
              {...register('description')}
              className={styles.textArea}
            />

            {/* VIDEO */}
            <input
              type="file"
              accept="video/*"
              {...register('video', { required: true })}
              className={styles.fileInput}
            />
            {errors.video && <span className={styles.errorText}>Video is required</span>}

            {selectedVideo?.length > 0 && (
              <p className={styles.fileName}>Selected: {selectedVideo[0].name}</p>
            )}

            {/* Upload progress */}
            {uploading && (
              <p className={styles.progressText}>Uploading: {uploadProgress}%</p>
            )}

            {/* ORDER */}
            <input
              type="number"
              placeholder="Order (optional)"
              {...register('order')}
              className={styles.inputField}
            />

            {/* CHECKBOXES */}
            <label className={styles.checkboxLabel}>
              <input type="checkbox" {...register('isPreview')} />
              Is Preview
            </label>

            <label className={styles.checkboxLabel}>
              <input type="checkbox" {...register('isPublished')} />
              Is Published
            </label>

            <button type="submit" className={styles.submitButton} disabled={uploading}>
              {uploading ? `Uploading ${uploadProgress}%` : 'Upload Video'}
            </button>
          </form>
        </section>

        <section className={styles.otherSection}>
          <video className={styles.backgroundVideo} src={circuit} autoPlay loop muted />
          <h1 className={styles.adminTitle}>ADMIN BY ERIC</h1>
          <p className={styles.adminSubtitle}>
            Do not tamper with the untempered system
          </p>
        </section>
      </div>
    </div>
  );
};

export default Upload;
